import { render, staticRenderFns } from "./starRatingMini.vue?vue&type=template&id=5a5b8aa4&scoped=true"
import script from "./starRatingMini.vue?vue&type=script&lang=js"
export * from "./starRatingMini.vue?vue&type=script&lang=js"
import style0 from "./starRatingMini.vue?vue&type=style&index=0&id=5a5b8aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b8aa4",
  null
  
)

export default component.exports